import { uniqBy, orderBy, values } from "lodash";

import { getUniqueItemWithStorageId } from "utils/hardwareUtils";

import {
  getSelectedExtendedVariant,
  getStockedAccessoryExtendedVariant,
} from "utils/variantUtils";

const sortByPrice = (items, getPriceVal) =>
  items.sort((a, b) => {
    const priceA = getPriceVal(a);
    const priceB = getPriceVal(b);

    if (priceA === priceB) {
      return 0;
    }

    return priceA > priceB ? 1 : -1;
  });

const sortByIndex = (items) => items.sort((a, b) => a.idx - b.idx);

const prepareItemsForHardware = (items, sortByName) =>
  sortByName !== "price"
    ? sortByIndex(items)
    : sortByPrice(
        items,
        ({ defaultVariant, variants }) => variants[defaultVariant].price
      );

const prepareItemsForTariff = (items, sortByName) =>
  sortByName !== "price"
    ? sortByIndex(items)
    : sortByPrice(items, ({ calculations: { totalPrice } }) => totalPrice);

const getAccessoriesStock = (accessories = []) =>
  Math.min(...accessories.map((acc) => acc.stock));

const getAvailableAccessoriesVariants = (accessories = []) =>
  accessories.map((acc) => {
    if (!acc.extendedVariants) {
      return acc;
    }

    const extendedVariant = getStockedAccessoryExtendedVariant(
      acc.extendedVariants
    );

    return {
      ...acc,
      stock: extendedVariant.variant.stock,
      image: extendedVariant.variant.images,
    };
  });

export const prepareItems = (items, sortDirection, sortByName, isTariff) => {
  // Filter hardware with different color, just use variants instead of hardwares and
  // prepare each item with idx for sorting to "recommendations"
  // and for sorting sold out items
  const itemsToSort = uniqBy(items, getUniqueItemWithStorageId).map(
    (item, idx) => ({
      ...item,
      idx: idx + 1,
      // to calculate stock here we only check the min of the hardware and its variant
      // the context of the currently selected variant is not required
      isSoldOut: !isTariff
        ? Math.min(
            item.stock,
            // convert the variants to a an array like hardware extendedVariants
            // TODO: Backend should send the same data structure
            getSelectedExtendedVariant(values(item.variants)).stock,
            getAccessoriesStock(
              getAvailableAccessoriesVariants(item.accessories)
            )
          ) <= 0
        : undefined,
      accessories: getAvailableAccessoriesVariants(item.accessories),
    })
  );

  const preparedItems = isTariff
    ? prepareItemsForTariff(itemsToSort, sortByName)
    : orderBy(prepareItemsForHardware(itemsToSort, sortByName), "isSoldOut");

  if (sortDirection === "desc") {
    return preparedItems.reverse();
  }
  return preparedItems;
};

export default prepareItems;
